$(function(){
  // init 前に複製
  var upperHTML = $('.top_voice_ticker_item').first().prop('outerHTML');
  var lowerHTML = $('.top_voice_ticker_bottom .top_voice_ticker_item').first().prop('outerHTML');
  for (var i=0; i<20; i++){
    $('.top_voice_ticker').append(upperHTML);
    $('.top_voice_ticker_bottom').append(lowerHTML);
  }

  $('.top_voice_ticker').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10,
    speed: 120000,
    cssEase: 'linear',
    variableWidth: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    infinite: true
  });

  $('.top_voice_ticker_bottom').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10,
    speed: 150000,
    cssEase: 'linear',
    variableWidth: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    infinite: true
  });
});
